const BADGE_COLORS = {
  success: "bg-palette-emerald-soft text-palette-emerald-badge",
  danger: "bg-palette-rose-soft text-palette-rose-badge",
  neutral: "bg-palette-indigo-soft text-palette-indigo-heading",
  warning: "bg-palette-amber-soft text-palette-amber-heading",
  purple: "bg-palette-purple-muted text-palette-purple-heading",
  sky: "bg-palette-sky-muted text-smiles-blue",
  emerald: "bg-palette-emerald-muted text-smiles-green",
  slate: "bg-palette-slate-muted text-smiles-gray",
  gray: "bg-palette-gray-subtle text-palette-gray-secondary",
  indigo: "bg-palette-indigo-muted text-palette-indigo-heading",
  red: "bg-palette-red-muted text-palette-red-heading",
  amber: "bg-palette-amber-muted text-palette-amber-heading",
  lime: "bg-palette-lime-muted text-palette-lime-heading",
};

/** Role id (1, 2, 3, …) → Badge color key. Use with <Badge color={getBadgeColorForRole(role)} /> */
export function getBadgeColorForRole(role) {
  if (role === 1) return "purple";
  if (role === 2) return "sky";
  if (role === 3) return "emerald";
  if (role === 4) return "amber";
  if (role === 5) return "gray";
  if (role === 6) return "indigo"; // Observer (read-only)
  if (role === 7) return "lime"; // Payroll
  if (role === 8) return "warning"; // Bookkeeper
  return "slate";
}

export default function Badge({ children, color, title, className = "" }) {
  const map = BADGE_COLORS;
  const baseClasses =
    "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap";
  // When color key is set, use mapped color; otherwise use className (e.g. custom Tailwind from columnItem). Call sites can always pass both.
  const useColorFromMap = color && map[color];
  const resolvedClasses = useColorFromMap
    ? `${baseClasses} ${map[color]} ${className || ""}`.trim()
    : `${baseClasses} ${className || map.neutral}`.trim();

  return (
    <span className={resolvedClasses} title={title}>
      {children}
    </span>
  );
}
